// extracted by mini-css-extract-plugin
module.exports = {"modal":"FeedModalEdit_modal__2R55h","outside":"FeedModalEdit_outside__2NOV4"};